import error from './error'

export default {
  lang: {
    code: 'en',
    name: 'English'
  },
  nav: {
    minting: 'Minting',
    collection: 'Collection',
    portfolio: 'My Portfolio',
    changeWallet: 'Change Wallet',
    disconnectWallet: 'Disconnect Wallet',
    token: 'Token #{0} Details',
    provenance: 'Provenance',
    termsAndConditions: 'Terms & Conditions'
  },
  minting: {
    titleSale: 'Minting',
    titlePresale: 'Presale Minting',
    saleStartsSoon: 'The QBits sale will start soon',
    setMaxTokens: 'Set Max',
    totalPrice: 'Total price',
    estimatedGas: 'Estimated gas cost for Tx',
    accountBalance: 'Current account balance',
    accountTokensBalance: 'QBits you own',
    mintInPresale: 'Mint QBits in Presale',
    mintInSale: 'Mint QBits',
    notInPresale: 'Your account is not in the presale whitelist, please wait for the public sale.'
  },
  token: {
    genericTokenTitle: 'Token # {0}',
    idOutOfBound: 'Token ID is out of bound',
    dataUnavailable: 'Token information not available',
    descriptionUnavailable: 'Description unavailable',
    viewDetails: 'View Details',
    loadingDetails: 'Loading token details',
    owner: 'Owner',
    tradeInOpenSea: 'Trade token in OpenSea',
    requestHRContent: 'Request high-resolution content',
    openHRContent: 'Open high-resolution content',
    buyInOpenSea: 'Buy QBits in OpenSea',
    noTokensInPortfolio: 'You don\'t have any QBits in portfolio.'
  },
  provenance: {
    title: 'The QBits Provenance Record',
    descriptionLine1: 'This page presents the provenance record of all The QBit that will ever exist.',
    descriptionLine2: 'Each QBit image is firstly hashed using SHA-256 algorithm. A combined string is obtained by concatenating the SHA-256 hash of each QBit image in the specific order as listed below. The final proof is obtained by SHA-256 hashing this combined string. This is the final provenance record stored on the smart contract.',
    importantInfoTitle: 'Important Information',
    contractAddr: 'Contract address',
    deployedTo: 'Deployed to',
    provenanceHash: 'Provenance hash',
    finalStartingIndex: 'Final starting index',
    concatenatedStringTitle: 'Concatenated Hash String',
    provenanceTableTitle: 'Provenance Records Table',
    provenanceTable: {
      initialIndex: 'Initial Index',
      assignedId: 'Assigned Token ID',
      sha256Hash: 'SHA-256 Hash',
      ipfsFile: 'IPFS File'
    },
    viewProvenanceFile: 'View Provenance File'
  },
  footer: {
    copyright: '©2022 TheQbits. All rights reserved.',
    buildHash: 'Build hash'
  },
  error404: {
    error404: 'Error 404',
    routeNotFound: 'Route not found',
    backToCollection: 'Go back to Collection'
  },
  shared: {
    connect: 'Connect',
    connectWallet: 'Connect Wallet',
    switchToEth: 'Switch Chain to ETH',
    unique: 'Unique',
    rare: 'Rare',
    handmade: 'Handmade',
    whatYouStand: 'What you stand for?'
  },
  validations: {
  },
  error,
  success: {
  }
}
